import React, { useContext } from 'react';
import { Typography, Checkbox, Grid, Modal, Button } from '@mui/material';

import PaymentContext from '../PaymentContext';
import InformationModal from '../../prescriptions/information-modal';

/**
 * @param {object} props
 * @param {boolean} [props.isConsultationOrBooking=false]
 * @param {boolean} props.modalOpen
 * @param {Function} props.setModalOpen
 * @returns {JSX.Element|null}
 */
export const TreatmentTerms = ({ isConsultationOrBooking = false, modalOpen, setModalOpen }) => {
  const { treatmentsToRead, isCheckoutLoaded, termsRead, handleTermsRead, shippingAlert } = useContext(PaymentContext);

  if (isCheckoutLoaded || isConsultationOrBooking || !treatmentsToRead.length) {
    return null;
  }

  return (
    <>
      <Typography variant="body1" sx={{ mb: '20px' }}>
        <Checkbox checked={termsRead || false} onClick={handleTermsRead} />I have read the{' '}
        <Button variant="text" onClick={() => setModalOpen(true)} sx={{ textTransform: 'none' }}>
          treatment information
        </Button>
      </Typography>

      <Modal open={modalOpen}>
        <Grid sx={{ m: { xs: '30px', sm: '40px' } }}>
          <InformationModal setModalOpen={setModalOpen} selectedTreatments={treatmentsToRead} />
        </Grid>
      </Modal>

      {shippingAlert && (
        <Typography variant="body2" color="secondary" sx={{ m: '-20px 0px 20px 0px' }}>
          {shippingAlert}
        </Typography>
      )}
    </>
  );
};
